jQuery('.work-sort').click(function(){
	
	var filter = jQuery( this ).data( 'filter' );
	var element = '.work-item[data-filter="' + filter + '"]';
	
	jQuery( '.all' ).removeClass('active');
	jQuery( '.work-sort' ).removeClass('active');
	jQuery( '.work-item' ).hide();
	
	jQuery(this).addClass('active');
	jQuery(element).show();
	
});

jQuery('.all').click(function(){
	
	jQuery( this ).addClass('active');
	jQuery( '.work-sort' ).removeClass('active');
	jQuery( '.work-item' ).show();
	
});